module.exports = __webpack_public_path__ + "bpc_icon.png?cbcad3b883fa96cf8e8b759f7bfe2026";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/bpc_icon.png
// module id = 222
// module chunks = 0